const templateAutoTrainingOptions = players => players.map(option => `
  <div class="radio-option d-flex align-items-center">
    <input ${option.checked ? 'checked="checked"' : ''} required class="radio-option__input" name="autoTrainingOptionId" type="radio" value="${option.id}" id="auto-player-${option.id}" />
    <label class="radio-option__label d-flex align-items-center" for="auto-player-${option.id}">
      <div class="">
        ${option.name}
      </div>
      <div class="ml-auto">
       ${option.cost}
      </div>
    </label>
  </div>
`).join('');

export default templateAutoTrainingOptions;
